import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useMemo } from "react";
import { FloatingLeftButton } from "@/components/FloatingLeftButton";
import { Spinner } from "@/components/ui/spinner";
import KothHistory from "@/components/KothHistory";
import { useKothGlobalHistoryInfinite } from "@/lib/hooks/useApi";
import { t } from "@/lib/i18n";

function KothHistoryPage() {
  const router = useRouter();
  const kothType = 1 as const;

  const {
    data,
    isLoading,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useKothGlobalHistoryInfinite(kothType);

  const koths = useMemo(() => {
    const pages = data?.pages ?? [];
    return pages.flatMap((p) => p.koths ?? []);
  }, [data]);

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="bg-[#1D2A52] flex flex-1 flex-col h-full overflow-hidden p-1 gap-4 min-h-0">
      <FloatingLeftButton
        onClick={() => router.navigate({ to: "/koth" })}
        className="absolute left-0 top-4 z-50"
        icon={
          <svg
            className="w-4 h-4"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 1V0H2V1H1V2H0V3H1V4H2V5H3V4H6V7H3V8H7V7H8V6H9V3H8V2H7V1H3Z"
              fill="white"
            />
          </svg>
        }
      />

      <div className="flex-1 flex flex-col p-1 gap-4 w-full min-h-0 mt-10">
        <div className="text-center flex flex-col gap-2">
          <p className="text-white text-3xl font-extrabold text-shadow-black">
            {t("koth.kothHistory")}
          </p>
        </div>

        <div className="flex-1 flex flex-col overflow-hidden min-h-0 mt-3">
          <KothHistory
            koths={koths}
            walletAddress={"global"}
            refetchKothHistory={refetch}
            onLoadMore={() => fetchNextPage()}
            hasMore={!!hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isGlobalHistory={true}
            kothType={kothType}
          />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/(game)/koth/history")({
  component: KothHistoryPage,
});
